import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as sitesApi from "../../services/sites";
import * as adminApi from "../../services/admin";
import { errorMessage } from "../../services";
import { logout } from "./authSlice";

// Website list and dashboard overview, loaded from the API
export const fetchSites = createAsyncThunk("site/fetchSites", async (params, { rejectWithValue }) => {
  try {
    const { data } = await sitesApi.getSites(params);
    return data;
  } catch (err) {
    return rejectWithValue(errorMessage(err));
  }
});

export const fetchOverview = createAsyncThunk("site/fetchOverview", async (_, { rejectWithValue }) => {
  try {
    const { data } = await adminApi.getOverview();
    return data.stats;
  } catch (err) {
    return rejectWithValue(errorMessage(err));
  }
});

const initialState = {
  sites: [],
  total: 0,
  page: 1,
  pages: 1,
  loading: false,
  error: null,
  requestId: null, // the newest list request; answers to older ones are ignored
  overviewStats: null,
  overviewError: null,
};

const siteSlice = createSlice({
  name: "site",
  initialState,
  reducers: {
    // A deleted website leaves the list at once, without waiting for the list to reload
    siteRemoved(state, action) {
      const before = state.sites.length;
      state.sites = state.sites.filter((site) => site.id !== action.payload);
      if (state.sites.length < before) state.total = Math.max(0, state.total - 1);
    },
  },
  extraReducers: (builder) => {
    builder
      // Nothing from one user's session may show up for the next person who signs in
      .addCase(logout, () => initialState)
      .addCase(fetchSites.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.requestId = action.meta.requestId;
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        const { sites, total, page, pages } = action.payload;
        Object.assign(state, { sites, total, page, pages, loading: false });
      })
      .addCase(fetchSites.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(fetchOverview.fulfilled, (state, action) => {
        state.overviewStats = action.payload;
        state.overviewError = null;
      })
      .addCase(fetchOverview.rejected, (state, action) => {
        state.overviewError = action.payload || action.error.message;
      });
  },
});

export const { siteRemoved } = siteSlice.actions;
export default siteSlice.reducer;
